export default "__VITE_ASSET__CNUYa6xW__"